import React from "react";
import AuditPDFGenerator from "./ReportPDFGenerator";

const data = {
  version: [
    {
      auditDetails: {
        AuditDetails: [
          {
            label: "CB Name",
            response: "Aay123",
          },
          {
            label: "CB Office Location",
            response: "India",
          },
          {
            label: "Audit Language",
            response: "English",
          },
          {
            label: "Audit Objective",
            response: "1",
          },
          {
            label: "Audit Criteria",
            response:
              "ISO 22000: 2018 Food Safety Management Systems, FSSC 22000 Additional Requirements (Version 6.0)",
          },
          {
            label: "Audit Delivery",
            response: "Onsite",
          },
          {
            label: "Audit Start Date",
            response: "2025-07-17",
          },
          {
            label: "Audit End Date",
            response: "2025-07-18",
          },
          {
            label: "Audit Duration",
            response: "1 hours 2 minutes",
          },
          {
            label: "Audit Type",
            response: "sustaining",
          },
          {
            label: "Version",
            response: 2,
          },
          {
            label: "Audit Focus Areas",
            response: [],
          },
          {
            label:
              "Will this be done in conjunction with FSSC Certification Audit?",
            response: true,
          },
          {
            label: "Correction Date",
            value: "NA",
          },
        ],
        auditTeam: [
          {
            label: "Lead Auditor",
            response: "Naba",
          },
          {
            label: "Lead Auditor Function",
            response: "Lead Auditor",
          },
          {
            label: "Additional Attendees",
            response: {},
          },
        ],
      },
      auditType: "sustaining",
      endDate: "2025-07-18",
      formId: "2025-0345",
      protocolDetails: {
        focusArea: [],
        nonconformanceLog: [
          {
            RequirementReference:
              "ISO 22000: 2018- 4 Context of the organization",
            detailsOfNonconformity: "Test",
            evidenceOfCorrection: null,
            evidenceOfNonconformity: "Test 1",
            isPreviousYear: true,
            nonConformanceStatus: "Open",
            nonconformityRating: "Critical",
            number: "2025-115-0001",
            requirementOptions: [
              "ISO 22000: 2018- 4 Context of the organization",
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
              "ISO 22000: 2018- 4.2 Understanding the needs and expectations of interested parties",
              "ISO 22000: 2018- 4.3 Determining the scope of the food safety management system",
              "ISO 22000: 2018- 4.4 Food safety management system",
              "ISO 22000: 2018- 5 Leadership",
              "ISO 22000: 2018- 5.1 Leadership and commitment",
            ],
            standardOrTechnicalSpecification:
              "ISO 22000: 2018 Food Safety Management Systems",
          },
          {
            RequirementReference:
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
            detailsOfNonconformity: "Test",
            evidenceOfCorrection: null,
            evidenceOfNonconformity: "Test 2",
            isPreviousYear: false,
            nonConformanceStatus: "Open",
            nonconformityRating: "Major",
            number: "2025-115-0002",
            requirementOptions: [
              "ISO 22000: 2018- 4 Context of the organization",
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
              "ISO 22000: 2018- 4.2 Understanding the needs and expectations of interested parties",
              "ISO 22000: 2018- 4.3 Determining the scope of the food safety management system",
              "ISO 22000: 2018- 4.4 Food safety management system",
              "ISO 22000: 2018- 5 Leadership",
            ],
            standardOrTechnicalSpecification:
              "ISO 22000: 2018 Food Safety Management Systems",
          },
          {
            RequirementReference:
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
            detailsOfNonconformity: "Test",
            evidenceOfCorrection: null,
            evidenceOfNonconformity: "Test 3",
            isPreviousYear: false,
            nonConformanceStatus: "Open",
            nonconformityRating: "Minor",
            number: "2025-115-0003",
            requirementOptions: [
              "ISO 22000: 2018- 4 Context of the organization",
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
              "ISO 22000: 2018- 4.2 Understanding the needs and expectations of interested parties",
              "ISO 22000: 2018- 4.3 Determining the scope of the food safety management system",
              "ISO 22000: 2018- 4.4 Food safety management system",
              "ISO 22000: 2018- 5 Leadership",
              "ISO 22000: 2018- 5.1 Leadership and commitment",
              "ISO 22000: 2018- 5.2 Policy",
              "ISO 22000: 2018- 5.2.1 Establishing the food safety policy",
              "ISO 22000: 2018- 5.2.2 Communicating the food safety policy",
            ],
            standardOrTechnicalSpecification:
              "ISO 22000: 2018 Food Safety Management Systems",
          },
        ],
        notCapturedFssc: [
          {
            "Details of Nonconformity":
              "At the main hygienic corridor prior to entrance to production, the cabinet with cleaning chemicals was unlocked. When opening the cabinet, the storage was found to be messy. Noted a pile of dirty cloths in the corner on the floor of the cabinet.",
            "Evidence Of Correction": null,
            "Evidence of Non-conformity":
              "At the main hygienic corridor prior to entrance to production, the cabinet with cleaning chemicals was unlocked. When opening the cabinet, the storage was found to be messy. Noted a pile of dirty cloths in the corner on the floor of the cabinet.",
            "Is Previous Year": true,
            "NonConformance Status": "OPEN",
            "Nonconformity Rating": "Minor",
            "Number (#)": "5812454_ROTMOX02",
            "Requirement Reference":
              "ISO/TS 22002-1: 2009- 5.7 Storage of food, packaging materials, ingredients and non-food chemicals",
            "Standard or Technical Specifications": "FSSC 22000 Food Safety v6",
          },
          {
            "Details of Nonconformity":
              "At the ambient raw materials storage area, two buckets with sulfite (1002726) and salt (1000443) were found with no traceability information on it other than the article number. No labels were seen with batch number nor expiry date so it could not be verified to which original batch they belong.",
            "Evidence Of Correction": null,
            "Evidence of Non-conformity":
              "At the ambient raw materials storage area, two buckets with sulfite (1002726) and salt (1000443) were found with no traceability information on it other than the article number. No labels were seen with batch number nor expiry date so it could not be verified to which original batch they belong.",
            "Is Previous Year": false,
            "NonConformance Status": "OPEN",
            "Nonconformity Rating": "Major",
            "Number (#)": "5812454_ROTMOX01",
            "Requirement Reference": "ISO 22000: 2018- 8.3 Traceability system",
            "Standard or Technical Specifications": "FSSC 22000 Food Safety v6",
          },
          {
            "Details of Nonconformity":
              'During an inspection of external areas conducted on 02/07/24, the storage of boiler chemicals was reviewed.It was observed that a drum of Nalco 2584 was stored within the bulk tank bund and not secured. Further to this it was identified as "2584" with a marker pen and the correct label was not adhered to the drum.No further issues observed with the storage of chemicals and so was assessed as low risk and a Minor was raised.',
            "Evidence Of Correction": null,
            "Evidence of Non-conformity":
              'During an inspection of external areas conducted on 02/07/24, the storage of boiler chemicals was reviewed.It was observed that a drum of Nalco 2584 was stored within the bulk tank bund and not secured. Further to this it was identified as "2584" with a marker pen and the correct label was not adhered to the drum.No further issues observed with the storage of chemicals and so was assessed as low risk and a Minor was raised.',
            "Is Previous Year": false,
            "NonConformance Status": "OPEN",
            "Nonconformity Rating": "Critical",
            "Number (#)": "5812454_COVDPT01",
            "Requirement Reference":
              "ISO/TS 22002-1: 2009- 6.3 Boiler chemicals",
            "Standard or Technical Specifications": "FSSC 22000 Food Safety v6",
          },
        ],

        data: {
          sections: ["Scoping", "Leadership", "Plan", "Do", "Check", "Act"],
          scoping: [
            {
              label:
                "Objective: Define the scope and boundaries of the Quality Management System (QMS) audit based on the organization’s context, products/services, and locations",
              response: "Test",
            },
            {
              label: "Were there any changes to scoping?*",
              response: "Test",
            },
          ],
          leadership: [
            {
              label:
                "Objective: Assess the effectiveness of leadership and commitment to the QMS",
              response: "Test",
            },
            {
              label: "Were there any changes to leadership?*",
              response: "Test",
            },
            
          ],
          plan: [
            {
              label:
                "Objective: Evaluate the planning and risk management processes within the QMS",
              response: "Test",
            },
            {
              label: "Were there any changes to planning?*",
              response: "Test",
            },
          ],
          do: [
            {
              label:
                "Objective: Review the implementation of the QMS processes and controls",
              response: "Test",
            },
            {
              label: "Were there any changes to implementation?*",
              response: "Test",
            },
          ],
          check: [
            {
              label:
                "Objective: Assess the monitoring, measurement, analysis, and evaluation of the QMS",
              response: "Test",
            },
            {
              label: "Were there any changes to checking?*",
              response: "Test",
            },
          ],
        },

        protocolType: "Addendum",
        protocolVersion: 1,
      },
      scoringDetails: {
        areaOfStrAndOps: [
          {
            desL: "Identify minimum 2 areas of strength for the unit and why",
            label: "AREAS OF STRENGTH",
            response: "1",
          },
          {
            desL: "Identify minimum 2 areas of opportunity for the unit and why",
            label: "AREAS OF OPPORTUNITY",
            response: "2",
          },
          {
            desL: "If this audit had zero findings - please justify the unit's success to share for learnings.",
            label: "",
            response: "3",
          },
        ],
        auditConclusion: [
          {
            category: [
              {
                name: "Compliant",
                status: false,
              },
              {
                name: "Needs Improvement",
                status: false,
              },
              {
                name: "At Risk",
                status: true,
              },
              {
                name: "Gap Assessment",
                status: false,
              },
            ],
            label: "Mars QMS Audit Conformance Level",
          },
        ],
        executiveSummary: [
          {
            category: "TotalNonconformancePoints",
            label: "Total Nonconformance Points",
            number: "24",
          },
          {
            category: "FSSCCertification",
            label: "Will be recommended for FSSC Certification?",
            number: "Yes",
          },
        ],
        executiveSummaryCertification: [
          {
            category: "Critical",
            noOfNonCon: "1",
            nonConPoints: "5",
          },
          {
            category: "Major",
            noOfNonCon: "1",
            nonConPoints: "4",
          },
          {
            category: "Minor",
            noOfNonCon: "1",
            nonConPoints: "3",
          },
        ],
        executiveSummaryResult: [
          {
            category: "Critical",
            noOfNonCon: "1",
            nonConPoints: "5",
          },
          {
            category: "Major",
            noOfNonCon: "1",
            nonConPoints: "4",
          },
          {
            category: "Minor",
            noOfNonCon: "1",
            nonConPoints: "3",
          },
        ],
        isFsscConjunction: true,
        protocolType: "Addendum",
      },
      startDate: "2025-07-17",
      unitDetails: {
        activity: "completed",
        formId: "2025-0345",
        status: "Active",
        unitDetails: [
          {
            label: "Unit Name",
            response: "115 - Mattoon (KKM)(Pet)",
          },
          {
            label: "Three-digit QMS Registration Number",
            response: "Mfg Site",
          },
          {
            label: "Manufacturing 3 letter code - if applicable",
            response: "KKM",
          },
          {
            label: "Location of Audit",
            response: "USA",
          },
          {
            label: "Quality Manager or Lead Auditee",
            response: "Rout, Nabasundar (Contractor)",
          },
          {
            label: "Quality Manager or Lead Auditee Email",
            response: "nabasundar.rout@effem.com",
          },
          {
            label: "Current Third-Party Certifications Held",
            response: "FSSC 22000 Additional Requirements (Version 6.0)",
          },
          {
            label: "Enterprise",
            response: "Mars Inc",
          },
          {
            label: "Responsible Segment",
            response: "Mars Petcare",
          },
          {
            label: "Responsible Division",
            response: "Global Pet Nutrition Division",
          },
          {
            label: "Responsible Business Unit",
            response: "Pet Nutrition NA BU",
          },
          {
            label: "Responsible Sub Business Unit",
            response: "Not Applicable",
          },
          {
            label: "Off-site activities applicable",
            response: "No",
          },
          {
            label: "If yes \u2013 what is the Type of offsite activity",
            response: "NA",
          },
          {
            label: "Site Name",
            response: "NA",
          },
          {
            label: "Is Location currently audited?",
            response: "NA",
          },
          {
            label: "If yes \u2013 who is auditing location?",
            response: "NA",
          },
        ],
        unitIndex: "115 - Mattoon (KKM)(Pet)",
      },
      unitIndex: "115 - Mattoon (KKM)(Pet)",
      version: "V1",
    },
    {
      auditDetails: {
        AuditDetails: [
          {
            label: "CB Name",
            response: "Aay123",
          },
          {
            label: "CB Office Location",
            response: "India",
          },
          {
            label: "Audit Language",
            response: "English",
          },
          {
            label: "Audit Objective",
            response: "1",
          },
          {
            label: "Audit Criteria",
            response:
              "ISO 22000: 2018 Food Safety Management Systems, FSSC 22000 Additional Requirements (Version 6.0)",
          },
          {
            label: "Audit Delivery",
            response: "Onsite",
          },
          {
            label: "Audit Start Date",
            response: "2025-07-17",
          },
          {
            label: "Audit End Date",
            response: "2025-07-18",
          },
          {
            label: "Audit Duration",
            response: "1 hours 2 minutes",
          },
          {
            label: "Audit Type",
            response: "sustaining",
          },
          {
            label: "Version",
            response: 2,
          },
          {
            label: "Audit Focus Areas",
            response: [],
          },
          {
            label:
              "Will this be done in conjunction with FSSC Certification Audit?",
            response: true,
          },
          {
            label: "Correction Date",
            value: "NA",
          },
        ],
        auditTeam: [
          {
            label: "Lead Auditor",
            response: "Naba",
          },
          {
            label: "Lead Auditor Function",
            response: "Lead Auditor",
          },
          {
            label: "Additional Attendees",
            response: {},
          },
        ],
      },
      auditType: "sustaining",
      endDate: "2025-07-18",
      formId: "2025-0345",
      protocolDetails: {
        focusArea: [],
        nonconformanceLog: [
          {
            RequirementReference:
              "ISO 22000: 2018- 4 Context of the organization",
            detailsOfNonconformity: "Test",
            evidenceOfCorrection: null,
            evidenceOfNonconformity: "Test 1",
            isPreviousYear: true,
            nonConformanceStatus: "Open",
            nonconformityRating: "Critical",
            number: "2025-115-0001",
            requirementOptions: [
              "ISO 22000: 2018- 4 Context of the organization",
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
              "ISO 22000: 2018- 4.2 Understanding the needs and expectations of interested parties",
              "ISO 22000: 2018- 4.3 Determining the scope of the food safety management system",
              "ISO 22000: 2018- 4.4 Food safety management system",
              "ISO 22000: 2018- 5 Leadership",
              "ISO 22000: 2018- 5.1 Leadership and commitment",
            ],
            standardOrTechnicalSpecification:
              "ISO 22000: 2018 Food Safety Management Systems",
          },
          {
            RequirementReference:
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
            detailsOfNonconformity: "Test",
            evidenceOfCorrection: null,
            evidenceOfNonconformity: "Test 2",
            isPreviousYear: false,
            nonConformanceStatus: "Open",
            nonconformityRating: "Major",
            number: "2025-115-0002",
            requirementOptions: [
              "ISO 22000: 2018- 4 Context of the organization",
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
              "ISO 22000: 2018- 4.2 Understanding the needs and expectations of interested parties",
              "ISO 22000: 2018- 4.3 Determining the scope of the food safety management system",
              "ISO 22000: 2018- 4.4 Food safety management system",
              "ISO 22000: 2018- 5 Leadership",
            ],
            standardOrTechnicalSpecification:
              "ISO 22000: 2018 Food Safety Management Systems",
          },
          {
            RequirementReference:
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
            detailsOfNonconformity: "Test",
            evidenceOfCorrection: null,
            evidenceOfNonconformity: "Test 3",
            isPreviousYear: false,
            nonConformanceStatus: "Open",
            nonconformityRating: "Minor",
            number: "2025-115-0003",
            requirementOptions: [
              "ISO 22000: 2018- 4 Context of the organization",
              "ISO 22000: 2018- 4.1 Understanding the organization and its context",
              "ISO 22000: 2018- 4.2 Understanding the needs and expectations of interested parties",
              "ISO 22000: 2018- 4.3 Determining the scope of the food safety management system",
              "ISO 22000: 2018- 4.4 Food safety management system",
              "ISO 22000: 2018- 5 Leadership",
              "ISO 22000: 2018- 5.1 Leadership and commitment",
              "ISO 22000: 2018- 5.2 Policy",
              "ISO 22000: 2018- 5.2.1 Establishing the food safety policy",
              "ISO 22000: 2018- 5.2.2 Communicating the food safety policy",
            ],
            standardOrTechnicalSpecification:
              "ISO 22000: 2018 Food Safety Management Systems",
          },
        ],
        notCapturedFssc: [
          {
            "Details of Nonconformity":
              "At the main hygienic corridor prior to entrance to production, the cabinet with cleaning chemicals was unlocked. When opening the cabinet, the storage was found to be messy. Noted a pile of dirty cloths in the corner on the floor of the cabinet.",
            "Evidence Of Correction": null,
            "Evidence of Non-conformity":
              "At the main hygienic corridor prior to entrance to production, the cabinet with cleaning chemicals was unlocked. When opening the cabinet, the storage was found to be messy. Noted a pile of dirty cloths in the corner on the floor of the cabinet.",
            "Is Previous Year": true,
            "NonConformance Status": "OPEN",
            "Nonconformity Rating": "Minor",
            "Number (#)": "5812454_ROTMOX02",
            "Requirement Reference":
              "ISO/TS 22002-1: 2009- 5.7 Storage of food, packaging materials, ingredients and non-food chemicals",
            "Standard or Technical Specifications": "FSSC 22000 Food Safety v6",
          },
          {
            "Details of Nonconformity":
              "At the ambient raw materials storage area, two buckets with sulfite (1002726) and salt (1000443) were found with no traceability information on it other than the article number. No labels were seen with batch number nor expiry date so it could not be verified to which original batch they belong.",
            "Evidence Of Correction": null,
            "Evidence of Non-conformity":
              "At the ambient raw materials storage area, two buckets with sulfite (1002726) and salt (1000443) were found with no traceability information on it other than the article number. No labels were seen with batch number nor expiry date so it could not be verified to which original batch they belong.",
            "Is Previous Year": false,
            "NonConformance Status": "OPEN",
            "Nonconformity Rating": "Major",
            "Number (#)": "5812454_ROTMOX01",
            "Requirement Reference": "ISO 22000: 2018- 8.3 Traceability system",
            "Standard or Technical Specifications": "FSSC 22000 Food Safety v6",
          },
          {
            "Details of Nonconformity":
              'During an inspection of external areas conducted on 02/07/24, the storage of boiler chemicals was reviewed.It was observed that a drum of Nalco 2584 was stored within the bulk tank bund and not secured. Further to this it was identified as "2584" with a marker pen and the correct label was not adhered to the drum.No further issues observed with the storage of chemicals and so was assessed as low risk and a Minor was raised.',
            "Evidence Of Correction": null,
            "Evidence of Non-conformity":
              'During an inspection of external areas conducted on 02/07/24, the storage of boiler chemicals was reviewed.It was observed that a drum of Nalco 2584 was stored within the bulk tank bund and not secured. Further to this it was identified as "2584" with a marker pen and the correct label was not adhered to the drum.No further issues observed with the storage of chemicals and so was assessed as low risk and a Minor was raised.',
            "Is Previous Year": false,
            "NonConformance Status": "OPEN",
            "Nonconformity Rating": "Critical",
            "Number (#)": "5812454_COVDPT01",
            "Requirement Reference":
              "ISO/TS 22002-1: 2009- 6.3 Boiler chemicals",
            "Standard or Technical Specifications": "FSSC 22000 Food Safety v6",
          },
        ],

        data: {
          sections: ["Scoping", "Leadership", "Plan", "Do", "Check", "Act"],
          scoping: [
            {
              label:
                "Objective: Define the scope and boundaries of the Quality Management System (QMS) audit based on the organization’s context, products/services, and locations",
              response: "Test",
            },
            {
              label: "Were there any changes to scoping?*",
              response: "Test",
            },
          ],
          leadership: [
            {
              label:
                "Objective: Assess the effectiveness of leadership and commitment to the QMS",
              response: "Test",
            },
            {
              label: "Were there any changes to leadership?*",
              response: "Test",
            },
            
          ],
          plan: [
            {
              label:
                "Objective: Evaluate the planning and risk management processes within the QMS",
              response: "Test",
            },
            {
              label: "Were there any changes to planning?*",
              response: "Test",
            },
          ],
          do: [
            {
              label:
                "Objective: Review the implementation of the QMS processes and controls",
              response: "Test",
            },
            {
              label: "Were there any changes to implementation?*",
              response: "Test",
            },
          ],
          check: [
            {
              label:
                "Objective: Assess the monitoring, measurement, analysis, and evaluation of the QMS",
              response: "Test",
            },
            {
              label: "Were there any changes to checking?*",
              response: "Test",
            },
          ],
        },

        protocolType: "Addendum",
        protocolVersion: 1,
      },
      scoringDetails: {
        areaOfStrAndOps: [
          {
            desL: "Identify minimum 2 areas of strength for the unit and why",
            label: "AREAS OF STRENGTH",
            response: "1",
          },
          {
            desL: "Identify minimum 2 areas of opportunity for the unit and why",
            label: "AREAS OF OPPORTUNITY",
            response: "2",
          },
          {
            desL: "If this audit had zero findings - please justify the unit's success to share for learnings.",
            label: "",
            response: "3",
          },
        ],
        auditConclusion: [
          {
            category: [
              {
                name: "Compliant",
                status: false,
              },
              {
                name: "Needs Improvement",
                status: false,
              },
              {
                name: "At Risk",
                status: true,
              },
              {
                name: "Gap Assessment",
                status: false,
              },
            ],
            label: "Mars QMS Audit Conformance Level",
          },
        ],
        executiveSummary: [
          {
            category: "TotalNonconformancePoints",
            label: "Total Nonconformance Points",
            number: "24",
          },
          {
            category: "FSSCCertification",
            label: "Will be recommended for FSSC Certification?",
            number: "Yes",
          },
        ],
        executiveSummaryCertification: [
          {
            category: "Critical",
            noOfNonCon: "1",
            nonConPoints: "5",
          },
          {
            category: "Major",
            noOfNonCon: "1",
            nonConPoints: "4",
          },
          {
            category: "Minor",
            noOfNonCon: "1",
            nonConPoints: "3",
          },
        ],
        executiveSummaryResult: [
          {
            category: "Critical",
            noOfNonCon: "1",
            nonConPoints: "5",
          },
          {
            category: "Major",
            noOfNonCon: "1",
            nonConPoints: "4",
          },
          {
            category: "Minor",
            noOfNonCon: "1",
            nonConPoints: "3",
          },
        ],
        isFsscConjunction: true,
        protocolType: "Addendum",
      },
      startDate: "2025-07-17",
      unitDetails: {
        activity: "completed",
        formId: "2025-0345",
        status: "Active",
        unitDetails: [
          {
            label: "Unit Name",
            response: "115 - Mattoon (KKM)(Pet)",
          },
          {
            label: "Three-digit QMS Registration Number",
            response: "Mfg Site",
          },
          {
            label: "Manufacturing 3 letter code - if applicable",
            response: "KKM",
          },
          {
            label: "Location of Audit",
            response: "USA",
          },
          {
            label: "Quality Manager or Lead Auditee",
            response: "Rout, Nabasundar (Contractor)",
          },
          {
            label: "Quality Manager or Lead Auditee Email",
            response: "nabasundar.rout@effem.com",
          },
          {
            label: "Current Third-Party Certifications Held",
            response: "FSSC 22000 Additional Requirements (Version 6.0)",
          },
          {
            label: "Enterprise",
            response: "Mars Inc",
          },
          {
            label: "Responsible Segment",
            response: "Mars Petcare",
          },
          {
            label: "Responsible Division",
            response: "Global Pet Nutrition Division",
          },
          {
            label: "Responsible Business Unit",
            response: "Pet Nutrition NA BU",
          },
          {
            label: "Responsible Sub Business Unit",
            response: "Not Applicable",
          },
          {
            label: "Off-site activities applicable",
            response: "No",
          },
          {
            label: "If yes \u2013 what is the Type of offsite activity",
            response: "NA",
          },
          {
            label: "Site Name",
            response: "NA",
          },
          {
            label: "Is Location currently audited?",
            response: "NA",
          },
          {
            label: "If yes \u2013 who is auditing location?",
            response: "NA",
          },
        ],
        unitIndex: "115 - Mattoon (KKM)(Pet)",
      },
      unitIndex: "115 - Mattoon (KKM)(Pet)",
      version: "V1",
    },
  ],
  versionInfo: ["V2", "V1"],
};

const AddendumDownloadPDF = ({ formid, version, type }) => {
  return (
    <>
      <AuditPDFGenerator
        formid={formid}
        version={version}
        type={type}
        data={data}
      />
    </>
  );
};

export default AddendumDownloadPDF;
